import {l} from "types/typescriptdefinisjoner_lederplan";
import {BasisRessurs} from "felles/infrastruktur/BasisRessurs";
import {RessursFeilhåndtering} from "../RessursFeilhåndtering";
import {gettextCatalog} from "angular-gettext";
import _ from "lodash";
import moment, {Moment} from "moment";
import {regNavn} from "../tredjepartsTjenestenavn";
import {MøteRessurs} from "./MøteRessurs";
import {KommentarerTjeneste} from "../modulspesifikke/KommentarTjeneste";
import {Debugger} from "debug";
import {Konfigurasjon} from "../../infrastruktur/Konfigurasjon";
import {Filer} from "../Filer";
import {uriEnkodet} from "../../stoettefunk/uri";
import {Møtedatoer} from "felles/tjenester/møte/Møtedatoer";

const debug:Debugger = require('debug')('SakRessurs');

export class SakRessurs extends BasisRessurs<l.AgendaelementModell> {

    static regNavn = "SakRessurs";

    static forInjisering() {
        return [
            regNavn.ng.$resource,
            Konfigurasjon.regNavn,
            RessursFeilhåndtering.regNavn,
            regNavn.gettext.gettextCatalog,
            SakRessurs
        ]
    }

    constructor($resource: ng.resource.IResourceService,
                private konfigurasjon: Konfigurasjon,
                ressursFeilhåndtering: RessursFeilhåndtering,
                gettextCatalog: gettextCatalog) {
        super("sak",
            $resource,
            ressursFeilhåndtering,
            gettextCatalog,
            {
                oppdaterPause: {method: 'POST', url: '/api/sak/pause/:id', params: {id: '@id'}},
                opprettSaker: {method: 'PUT', url: '/api/sak/opprettSaker', isArray: true},  /* om params utelates blir url /<ressursnavn>/id.. */
                oppdaterReferat: {method: 'POST', url: '/api/sak/:id/referat', params: {id: '@id'}},
                oppdaterReferatOgBeslutninger: {method: 'POST', url: '/api/sak/:id/referatOgBeslutninger', params: {id: '@sakId'}},
                opprettKommentar: {method: 'PUT', url: '/api/sak/opprettKommentar/:sakId', params: {id: '', sakId: '@sakId'}},
                opprettOppgave: {method: 'PUT', url: '/api/sak/opprettOppgave/:sakId', params: {id: '', sakId: '@sakId'}},
                opprettAgendaDokument: {method: 'PUT', url: '/api/sak/:id/opprettAgendaDokument', params: {id: '@id'}},
                opprettProtokollDokumentISak: {method: 'PUT', url: '/api/sak/:id/opprettProtokollDokumentISak/:moeteId', params: {id: '@id', moeteId: '@moeteId'}},
                opprettForfalteOppgaverDokument: {method: 'PUT', url: '/api/sak/:id/opprettForfalteOppgaverDokument', params: {id: '@id'}},
                oppdaterDokumentrekkefølge: {method: 'POST', url: '/api/sak/:id/oppdaterDokumentrekkefoelge'},
                opprettArkivDokumentISak: {method: 'PUT', url: '/api/sak/:id/opprettArkivDokumentISak', params: {id: '@id'}},
                slettOppgave: {method: 'DELETE', url: '/api/sak/:sakId/slettOppgave/:oppgaveId', params: {id: '', sakId: '@sakId', oppgaveId: '@oppgaveId'}},
                slettDokument: {method: 'DELETE', url: '/api/sak/:sakId/slettDokument/:dokumentId', params: {id: '', sakId: '@sakId', dokumentId: '@oppgaveId'}},
                finnSaksIdKnyttetTilBeslutning: {method: 'GET', url: '/api/sak/finnSaksIdKnyttetTilBeslutning', params: {id: ''}},
                finnForrigeSak: {method: 'GET', url: '/api/sak/:id/finnForrigeSak', params: {id: '@id'}},
                finnNesteSak: {method: 'GET', url: '/api/sak/:id/finnNesteSak', params: {id: '@id'}},
                finnSakerSomMaler: {method: 'POST', url: '/api/sak/finnSakerSomMaler'},
                brukersSaksoversikt: {method: 'GET', url: '/api/sak/brukersSaksoversikt', params: {id: ''}},
                brukersAntallsaker: {method: 'GET', url: '/api/sak/brukersAntallsaker', params: {id: ''}},
                flyttTilMoete: {method: 'POST', url: '/api/sak/:id/flyttTil/:moeteId', params: {id: '@id', moeteId: '@moeteId'}},
                hentSkjerming: {method: 'GET', url: '/api/sak/:id/skjerming', isArray: false},
                oppdaterSkjerming: {method: 'POST', url: '/api/sak/:id/skjerming', isArray: false, params: {id:'@id'}}
            });
    }

    //offentlige metoder

    brukersSaksoversikt(vedOk: (saker: l.GruppertTynnSakModell) => void = _.noop) {
        debug("brukersSakoversikt");
        return this.ressurs["brukersSaksoversikt"](null, vedOk, this.håndterFeil(()=>this.gettextCatalog.getString("Kunne ikke laste saksoversikt")));
    }

    brukersAntallsaker(vedOk: (antallSaker: l.BrukersSaksstatistikk) => void = _.noop) {
        debug("brukersAntallsaker");
        return this.ressurs["brukersAntallsaker"](null, vedOk, this.håndterFeil(()=>this.gettextCatalog.getString("Kunne ikke laste saksantall")));
    }

    finnForrigeSak(sakId: string, vedOk: (sak: l.AgendaelementModell) => void = _.noop) {
        debug("finnForrigeSak", sakId);
        return this.ressurs["finnForrigeSak"](
            {id: sakId},
            vedOk,
            this.håndterFeil(()=>this.gettextCatalog.getString("Kunne ikke finne forrige sak"))
        );
    }

    finnNesteSak(sakId: string, vedOk: (sak: l.AgendaelementModell) => void = _.noop) {
        debug("finnNesteSak", sakId);
        return this.ressurs["finnNesteSak"](
            {id: sakId},
            vedOk,
            this.håndterFeil(()=>this.gettextCatalog.getString("Kunne ikke finne neste sak"))
        );
    }

    finnSakerSomMaler(gruppeId: string, søkestreng: string): l.FinnSakerOgMalsakerResultatModell {
        debug("SøkRessurs.finnSakerSomMaler", søkestreng);
        return this.ressurs['finnSakerSomMaler'](
            {gruppeId: gruppeId, soekestreng: søkestreng},
            _.noop,
            this.håndterFeil(()=>this.gettextCatalog.getString("Kunne ikke finne saker")));
    }

    opprettSaker(saksspesifikasjoner: l.OpprettSakSpesifikasjon[]): ng.resource.IResourceArray<l.AgendaelementModell> {
        debug("opprettSaker", saksspesifikasjoner);
        return this.ressurs["opprettSaker"](
            saksspesifikasjoner,
            _.noop,
            this.håndterFeil(()=>this.gettextCatalog.getString("Kunne ikke opprette saker"))
        );
    }

    oppdaterPause(spesifikasjon: l.OppdaterPauseSpesifikasjon, vedOk: (sak: l.AgendaelementModell) => void = _.noop): l.AgendaelementModell {
        debug("oppdaterPause", spesifikasjon);
        return this.ressurs["oppdaterPause"](
            spesifikasjon,
            vedOk,
            this.håndterFeil(()=>this.gettextCatalog.getString('Kunne ikke oppdatere pause'))
        );
    }

    oppdaterReferat(sakId, referat): l.OkRespons {
        debug("oppdaterReferat", sakId, referat);
        return this.ressurs["oppdaterReferat"](
            {id: sakId, referat: referat},
            _.noop,
            this.håndterFeil(()=>this.gettextCatalog.getString("Kunne ikke oppdatere referat"))
        );
    }

    oppdaterReferatOgBeslutninger(spesifikasjon:l.SaksreferatSpesifikasjon): l.AgendaelementModell {
        debug("oppdaterReferatOgBeslutninger", spesifikasjon);
        return this.ressurs["oppdaterReferatOgBeslutninger"](
            spesifikasjon,
            _.noop,
            this.håndterFeil(()=>this.gettextCatalog.getString("Kunne ikke oppdatere referat"))
        );
    }

    opprettKommentar(sakId: string, spesifikasjon: l.OpprettKommentarSpesifikasjon, vedOk: (kommentar: l.KommentarModell) => void = _.noop): l.KommentarModell {
        debug("opprettKommentar", sakId, spesifikasjon);
        return this.ressurs["opprettKommentar"](
            _.defaults({sakId: sakId}, spesifikasjon),
            vedOk,
            this.håndterFeil(()=>this.gettextCatalog.getString("Kunne ikke opprette kommentar under sak"))
        );
    }

    opprettOppgave(sakId: string, spesifikasjon: l.MuterendeOppgaveSpesifikasjon, vedOk: (oppgave: l.OppgaveModell) => void = _.noop): l.OppgaveModell {
        debug("opprettOppgave", sakId, spesifikasjon);
        return this.ressurs["opprettOppgave"](
            _.defaults({sakId: sakId}, spesifikasjon),
            vedOk,
            this.håndterFeil(()=>this.gettextCatalog.getString("Kunne ikke opprette oppgave under sak"))
        );
    }

    opprettAgendaDokument(sakId: string): l.SaksdokumentModell {
        debug("opprettAgendaDokument", sakId);
        return this.ressurs["opprettAgendaDokument"](
            {id: sakId},
            _.noop,
            this.håndterFeil(()=>this.gettextCatalog.getString("Kunne ikke opprette agenda-dokument under sak"))
        );
    }

    opprettProtokollDokumentISak(sakId: string, møteId: string): l.SaksdokumentModell {
        debug("opprettProtokollDokumentISak", sakId, møteId);
        return this.ressurs["opprettProtokollDokumentISak"](
            {id: sakId, moeteId: møteId},
            _.noop,
            this.håndterFeil(()=>this.gettextCatalog.getString("Kunne ikke opprette protokoll-dokument under sak"))
        );
    }

    opprettForfalteOppgaverDokument(sakId: string): l.SaksdokumentModell {
        debug("opprettForfalteOppgaverDokument", sakId);
        return this.ressurs["opprettForfalteOppgaverDokument"](
            {id: sakId},
            _.noop,
            this.håndterFeil(()=>this.gettextCatalog.getString("Kunne ikke opprette forfalte oppgaver-dokument under sak"))
        );
    }

    opprettArkivDokumentISak(sakId:string, arkivFilnodeId:string, dokumentVersjonId:string) :l.SaksdokumentModell {
        debug("opprettArkivDokumentISak", sakId, arkivFilnodeId, dokumentVersjonId);
        return this.ressurs["opprettArkivDokumentISak"](
            {id: sakId, arkivFilnodeId: arkivFilnodeId, dokumentVersjonId: dokumentVersjonId},
            _.noop,
            this.håndterFeil(()=>this.gettextCatalog.getString("Kunne ikke opprette bibliotekdokument under sak"))
        );
    }

    oppdaterDokumentrekkefølge(sakId: string, dokumentrekkefølge: string[]): l.AgendaelementModell {
        debug("oppdaterDokumentrekkefølge", sakId, dokumentrekkefølge);
        return this.ressurs["oppdaterDokumentrekkefølge"](
            {id: sakId, dokumentrekkefoelge: dokumentrekkefølge},
            _.noop,
            this.håndterFeil(()=>this.gettextCatalog.getString("Kunne ikke oppdatere dokumentrekkefølge"))
        );
    }

    slettOppgave(sakId, oppgaveId, vedOk: () => void = _.noop) {
        debug("slettOppgave", sakId, oppgaveId)
        return this.ressurs["slettOppgave"](
            {sakId: sakId, oppgaveId: oppgaveId},
            vedOk,
            this.håndterFeil(()=>this.gettextCatalog.getString("Kunne ikke slette oppgave under sak"))
        );
    }

    slettDokument(sakId: string, dokumentId: string): l.AgendaelementModell {
        debug("slettDokument", sakId, dokumentId);
        return this.ressurs["slettDokument"](
            {sakId: sakId, dokumentId: dokumentId},
            _.noop,
            this.håndterFeil(()=>this.gettextCatalog.getString("Kunne ikke slette dokument"))
        );
    }

    finnSaksIdKnyttetTilBeslutning(beslutningId: string, vedOk: (entitet: l.EntitetIdRespons) => void = _.noop) {
        debug("finnSaksIdKnyttetTilBeslutning", beslutningId);
        return this.ressurs["finnSaksIdKnyttetTilBeslutning"](
            {beslutningId: beslutningId},
            vedOk,
            this.håndterFeil(()=>this.gettextCatalog.getString("Kunne ikke finne sak"))
        );
    }

    flyttTilMøte(sakId, møteId): l.OkRespons {
        return this.ressurs["flyttTilMoete"]({
            id: sakId,
            moeteId: møteId
        })
    }

    hentSkjerming(sakId: string): l.SkjermingDetaljerModell {
        debug("hentSkjerming", sakId);
        return <l.SkjermingDetaljerModell><any>this.ressurs['hentSkjerming'](
            {id: sakId},
            _.noop,
            this.håndterFeil(() => this.gettextCatalog.getString('Kunne ikke hente sak'))
        );
    }

    oppdaterSkjerming(sakId: string, spesifikasjon: l.OppdaterSkjermingSpesifikasjon): l.SkjermingDetaljerMedValideringsresultatModell<l.SkjermingValideringsfeil> {
        debug("oppdaterSkjerming", sakId);
        return this.ressurs['oppdaterSkjerming'](
            _.defaults({id: sakId}, spesifikasjon),
            _.noop,
            this.håndterFeil(() => this.gettextCatalog.getString('Kunne ikke oppdatere tilgangsbegrensning'))
        );
    }

    sakdokumentUrl(sak: l.AgendaelementModell) {
        const prefiks = this.gettextCatalog.getString('sak')
        const filnavn = Filer.somSikkertFilnavn(`${prefiks}-${sak.nummer}`)
        return `${this.konfigurasjon.serviceRotUrl}/api/sak/${sak.id}/pdf/${uriEnkodet(filnavn)}.pdf`
    }

    //statiske hjelpemetoder

    static saksstatistikk(sak: l.AgendaelementModell): Saksstatistikk {
        let alleOppgaver = _(sak.beslutninger)
            .map('oppgaver')
            .flatten() //alle beslutningers oppgaver
            .concat(sak.oppgaver) //legg til sakens oppgaver
            .countBy((oppgave: l.OppgaveModell) =>
                oppgave.utfoert ? "utført" : moment(oppgave.frist).isBefore() ? "forfalt" : "ikkeforfalt") //todo bruker OppgaveRessurs.oppgaveStatus (må først fjerne overskrides statusen)
            .value();
        let oppgaverForfalt = alleOppgaver["forfalt"] || 0;
        let oppgaverUtført = alleOppgaver["utført"] || 0;
        let oppgaverIkkeForfalt = alleOppgaver["ikkeforfalt"] || 0;
        let antOppgaver = oppgaverForfalt + oppgaverIkkeForfalt + oppgaverUtført;
        let antUlesteDokumenter = sak.dokumenter.filter(dokument => !dokument.erLestAv).length;
        let statistikk = {
            antKommentarer: KommentarerTjeneste.antallKommentarerOgSvar(sak.kommentarer),
            antDokumenter: sak.dokumenter.length,
            antUlesteDokumenter: antUlesteDokumenter,
            antBeslutninger: sak.beslutninger.length,
            antOppgaver: antOppgaver,
            antOppgaverForfalt: oppgaverForfalt,
            antOppgaverUtfoert: oppgaverUtført,
            antOppgaverIkkeForfalt: oppgaverIkkeForfalt,
            harForfalteOppgaver: oppgaverForfalt > 0,
            harKunUtfoerteOppgaver: oppgaverUtført === antOppgaver
        };
        return statistikk;
    }

    static sakssaker(møte: l.MøteModell): l.AgendaelementModell[] {
        return _(møte.saker)
            .filter(element => !element.erPause)
            .value()
    }

    static saksstatistikker(møte: l.MøteModell): { [sakId: string]: Saksstatistikk } {
        return _(møte.saker)
            .filter(element => !element.erPause)
            .reduce(
                (o, sak) => {
                    o[sak.id] = SakRessurs.saksstatistikk(sak);
                    return o
                },
                <{ [sakId: string]: Saksstatistikk }>{})
    }

    /** Returnerer objekt med ett innslag per sak.
     * For enkeltdagsmøter blir sakens varighet blir beregnet dersom ikke angitt på saken såfremt minst én sak har varighet angitt,
     * varighet blir da satt til udisponert tid / antall saker uten angitt varighet.
     * For flerdagsmøter er vi avhengige av at alle saker har varighet satt for at start/slutt dato skal kunne beregnes. */
    static sakstidspunkter(møte: { dato: l.MøteDato, saker: SaksinfoSakstidspunktberergning[] }): { [sakId: string]: Sakstidspunkt } {
        const varigheter = _(møte.saker).map(sak => sak.varighet);
        const erFlerdagsmøte = Møtedatoer.erFlerdagsmøte(møte.dato);
        const ingenVarigheterSatt = varigheter.every(_.isNull);
        const alleHarVarighetSatt = !varigheter.some(_.isNull);
        let forrigeSak: SaksinfoSakstidspunktberergning = null;
        if (erFlerdagsmøte && alleHarVarighetSatt) {
            let starttidspunkt = moment(møte.dato.start);
            let sakstidspunkter = _(møte.saker)
                .map(sak => {
                    if (!_.isNil(sak.starttidspunkt)) starttidspunkt = moment(sak.starttidspunkt); //sørg for å håndtere skifte i dag
                    let tidspunkt = Sakstidspunkt.flerdagsmøteMedTidspunkt(sak, starttidspunkt, forrigeSak);
                    forrigeSak = sak;
                    return tidspunkt
                })
                .keyBy('sakId')
                .value();
            debug('sakstidspunkter', sakstidspunkter)
            return sakstidspunkter;
        }
        if (erFlerdagsmøte) {
            let sakstidspunkter = _(møte.saker)
                .map(sak => {
                    let tidspunkt = Sakstidspunkt.flerdagsmøteUtenTidspunkt(sak, ingenVarigheterSatt, forrigeSak, møte.dato);
                    forrigeSak = sak;
                    return tidspunkt;
                })
                .keyBy('sakId')
                .value();
            debug('sakstidspunkter', sakstidspunkter)
            return sakstidspunkter;
        }
        if (ingenVarigheterSatt) {
            let sakstidspunkter = _(møte.saker)
                .map(sak => Sakstidspunkt.utenTidspunkt(sak.id))
                .keyBy('sakId')
                .value();
            debug('sakstidspunkter', sakstidspunkter)
            return sakstidspunkter;
        }

        const sumVarigheter = varigheter.sum();
        const møtetsVarighet = MøteRessurs.møtevarighet(møte);
        let stdSaksvarighet = (møtetsVarighet - sumVarigheter) / varigheter.filter(_.isNull).value().length;
        if (stdSaksvarighet < 0) stdSaksvarighet = 0;

        let starttidspunkt = moment(møte.dato.start);
        let sakstidspunkter = _(møte.saker)
            .map(sak => Sakstidspunkt.medTidspunkt(sak, stdSaksvarighet, starttidspunkt))
            .keyBy('sakId')
            .value();
        debug('sakstidspunkter', sakstidspunkter)
        return sakstidspunkter;
    }
}

interface SaksinfoSakstidspunktberergning {
    id: string;
    varighet: number;
    dag?: number;
    starttidspunkt?: Date;
}

export interface Saksstatistikk {
    antKommentarer: number;
    antDokumenter: number;
    antUlesteDokumenter:number;
    antBeslutninger: number;
    antOppgaver: number;
    antOppgaverForfalt: number;
    antOppgaverUtfoert: number;
    antOppgaverIkkeForfalt: number;
    harForfalteOppgaver: boolean;
    harKunUtfoerteOppgaver: boolean;
}

export class Sakstidspunkt {

    /** for bruk ved enkelt-dagsmøter når ingen saker har varighet satt */
    static utenTidspunkt(sakId: string): Sakstidspunkt{
        const instans = new Sakstidspunkt();
        instans.sakId = sakId;
        instans.flerdagsmoete = false;
        instans.foersteSakPaaDenneDag = false;
        instans.ingenVarigheterSatt = true;
        instans.varighetBeregnet = false;
        instans.varighetAngitt = false;
        instans.varighet = null;
        instans.start = null
        instans.slutt = null
        return instans;
    }

    /** for bruk ved enkelt-dagsmøter når noen eller alle sakene har varighet satt */
    static medTidspunkt(sak: SaksinfoSakstidspunktberergning, standardVarighet: number, starttidspunkt: Moment): Sakstidspunkt{
        const instans = new Sakstidspunkt();
        instans.sakId = sak.id;
        instans.flerdagsmoete = false;
        instans.foersteSakPaaDenneDag = false;
        instans.ingenVarigheterSatt = false;
        instans.varighetBeregnet = _.isNil(sak.varighet);
        instans.varighetAngitt = !_.isNil(sak.varighet);
        instans.varighet = instans.varighetBeregnet ? standardVarighet : sak.varighet;
        instans.start = starttidspunkt.clone().toDate();
        instans.slutt = starttidspunkt.add(instans.varighet, "minutes").clone().toDate();
        return instans;
    }

    /** for bruk ved heldagsmøter når alle saker har varighet angitt */
    static flerdagsmøteMedTidspunkt(sak: SaksinfoSakstidspunktberergning, starttidspunkt: Moment, forrigeSak: SaksinfoSakstidspunktberergning): Sakstidspunkt{
        const instans = new Sakstidspunkt();
        instans.sakId = sak.id;
        instans.flerdagsmoete = true;
        instans.foersteSakPaaDenneDag = forrigeSak?.dag != sak.dag;
        instans.ingenVarigheterSatt = false;
        instans.enkelteVarigheterIkkeSatt = false;
        instans.varighetBeregnet = false;
        instans.varighetAngitt = !_.isNil(sak.varighet);
        instans.dag = sak.dag;
        instans.varighet = sak.varighet;
        instans.start = starttidspunkt.clone().toDate();
        instans.slutt = starttidspunkt.add(instans.varighet, "minutes").clone().toDate();
        return instans;
    }

    /** for bruk ved heldagsmøter når IKKE alle saker har varighet angitt */
    static flerdagsmøteUtenTidspunkt(sak: SaksinfoSakstidspunktberergning, ingenVarigheterSatt:boolean, forrigeSak: SaksinfoSakstidspunktberergning, møtedato: l.MøteDato): Sakstidspunkt {
        const instans = new Sakstidspunkt();
        instans.sakId = sak.id;
        instans.flerdagsmoete = true;
        instans.foersteSakPaaDenneDag = forrigeSak?.dag != sak.dag;
        instans.ingenVarigheterSatt = ingenVarigheterSatt;
        instans.enkelteVarigheterIkkeSatt = true;
        instans.varighetBeregnet = false;
        instans.varighetAngitt = !_.isNil(sak.varighet);
        instans.dag = sak.dag;
        instans.varighet = sak.varighet;
        if (instans.foersteSakPaaDenneDag) instans.start = instans.dag == 0 ? møtedato.start : sak.starttidspunkt;
        instans.slutt = null;
        return instans;
    }

    sakId: string;
    ingenVarigheterSatt: boolean;
    enkelteVarigheterIkkeSatt: boolean;
    varighetBeregnet: boolean;
    varighetAngitt: boolean;
    flerdagsmoete: boolean;
    /** sann dersom dette er første sak på denne dag i et flerdagsmøte */
    foersteSakPaaDenneDag: boolean;
    /** angir dag (0 basert), ved flerdagsmøte */
    dag: number;
    varighet: number | null;
    /** sakens starttidspunkt, beregnet basert på angitte varigheter til foregående saker.
     * Dersom ingen saker i møte har varighet satt vil start=null.
     * Ved flerdagsmøter vil start kun være angitt for første sak på den enkelte dag dersom ikke varighet er angitt på alle saker */
    start: Date | null;
    slutt: Date | null;
}

export interface VarighetMedLabel {
    navn: string;
    verdi: number;
}
